// eslint-disable-next-line no-shadow
export enum ShouldShowModal {
  DETAIL,
  SALE,
}

// eslint-disable-next-line no-shadow
export enum FormInputName {
  orderId = 'orderId',
  ticket = 'ticket',
  label = 'label',
  value = 'value',
  paymentType = 'paymentType',
}
